import { z } from "zod";

import {
	AlternateQuoteSchema,
	CglQuoteLobDataSchema,
	CostLineItemSchema,
	EndorsementSchema,
	PartySchema,
	ProductsLiabilityQuoteLobDataSchema,
	QuoteAircraftSchema,
	UasQuoteLobDataSchema,
} from "./quote";

export const QUOTE_PRINT_PAYLOAD_VERSION = 1;

export const QUOTE_DOCUMENT_READY_PROPERTY = "__quoteDocumentReady";

export const QUOTE_DOCUMENT_READY_FLAG = `window.${QUOTE_DOCUMENT_READY_PROPERTY}`;

export const QuotePrintPayloadSchema = z.object({
	quoteId: z.string(),
	lob: z.string().nullable(),
	isBound: z.boolean(),
	policyNumber: z.string(),
	insured: PartySchema,
	producer: PartySchema,
	policyUseType: z.string(),
	inceptionDate: z.iso.date(),
	expiryDate: z.iso.date(),
	brokerCommission: z.number(),
	omitBrokerCommission: z.boolean().default(false),
	underwriter: z.string(),
	lineLead: z.string(),
	lineFollow: z.string().nullable(),
	lineSize: z.number(),
	lineRole: z.enum(["lead", "follow"]),
	aircraftData: z.array(QuoteAircraftSchema),
	productLiabilityLobData: ProductsLiabilityQuoteLobDataSchema.nullable(),
	cglLobData: CglQuoteLobDataSchema.nullable(),
	uasLobData: UasQuoteLobDataSchema.nullable().default(null),
	commisionBearingCosts: z.array(CostLineItemSchema),
	nonCommBearingCosts: z.array(CostLineItemSchema),
	totalDueAtInception: z.number(),
	combinedEndorsements: z.array(EndorsementSchema),
	endorsementSlugs: z.array(z.string()).default([]),
	pilotWarrantyMarkdown: z.string(),
	underwriterCommentsMarkdown: z.string(),
	alternateQuotes: z.array(AlternateQuoteSchema),
});

export type QuotePrintPayload = z.output<typeof QuotePrintPayloadSchema>;
